module.exports = __webpack_public_path__ + "static/img/diy-computer-name.1a42042.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/reformat/diy-computer-name.png
// module id = hzA0
// module chunks = 0